import { Auth } from 'aws-amplify';

export async function getUserAttributes() {
  try {
    const user = await getUser();
    const userAttributes = user?.signInUserSession?.idToken?.payload || {};
    return userAttributes;
  } catch (error) {
    return {};
  }
}

export async function getUser() {
  const user = await Auth.currentAuthenticatedUser();
  return user;
}

export async function setUserAttribute(attribute: string, value: string) {
  const user = await getUser();
  const update = {};
  update[`${attribute}`] = value;
  await Auth.updateUserAttributes(user, update);
}

export async function setOnboardingComplete(
  trackEvent: (event: Record<string, unknown>) => void,
) {
  try {
    await setUserAttribute('custom:completed_onboarding', '1');
    trackEvent({ event: 'onboarding_complete' });
  } catch (error) {}
}
